import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _set from "@babel/runtime-corejs3/helpers/set";
import _get from "@babel/runtime-corejs3/helpers/get";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _isNativeReflectConstruct from "@babel/runtime-corejs3/helpers/isNativeReflectConstruct";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime-corejs3/helpers/wrapNativeSuper";
import _objectSpread from "@babel/runtime-corejs3/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _createForOfIteratorHelper from "@babel/runtime-corejs3/helpers/createForOfIteratorHelper";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
function _superPropSet(t, e, o, r, p, f) { return _set(_getPrototypeOf(f ? t.prototype : t), e, o, r, p); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
import _Object$create from "@babel/runtime-corejs3/core-js-stable/object/create";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyNames from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-names";
import _Object$getPrototypeOf from "@babel/runtime-corejs3/core-js-stable/object/get-prototype-of";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Date$now from "@babel/runtime-corejs3/core-js-stable/date/now";
import _WeakMap from "@babel/runtime-corejs3/core-js-stable/weak-map";
import _Object$setPrototypeOf from "@babel/runtime-corejs3/core-js-stable/object/set-prototype-of";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _bindInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/bind";
import _flagsInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flags";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _Symbol from "@babel/runtime-corejs3/core-js-stable/symbol";
import _Symbol$toStringTag from "@babel/runtime-corejs3/core-js-stable/symbol/to-string-tag";
var __create = _Object$create;
var __defProp = _Object$defineProperty;
var __getOwnPropDesc = _Object$getOwnPropertyDescriptor;
var __getOwnPropNames = _Object$getOwnPropertyNames;
var __getProtoOf = _Object$getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = function __commonJS(cb, mod) {
  return function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
      exports: {}
    }).exports, mod), mod.exports;
  };
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};

// ../event-target-shim/index.js
var require_event_target_shim = __commonJS({
  "../event-target-shim/index.js": function _eventTargetShim_indexJs(exports) {
    "use strict";

    _Object$defineProperty(exports, "__esModule", {
      value: true
    });
    function assertType(condition, message) {
      if (!condition) {
        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }
        throw new TypeError(format(message, args));
      }
    }
    function format(message, args) {
      var i = 0;
      return message.replace(/%[os]/g, function () {
        return anyToString(args[i++]);
      });
    }
    function anyToString(x) {
      if (_typeof(x) !== "object" || x === null) {
        return String(x);
      }
      return Object.prototype.toString.call(x);
    }
    var currentErrorHandler;
    function setErrorHandler(value) {
      assertType(typeof value === "function" || value === void 0, "The error handler must be a function or undefined, but got %o.", value);
      currentErrorHandler = value;
    }
    function reportError(maybeError) {
      try {
        var error = maybeError instanceof Error ? maybeError : new Error(anyToString(maybeError));
        if (currentErrorHandler) {
          currentErrorHandler(error);
          return;
        }
        if (typeof dispatchEvent === "function" && typeof ErrorEvent === "function") {
          dispatchEvent(new ErrorEvent("error", {
            error: error,
            message: error.message
          }));
        } else if (typeof process !== "undefined" && typeof process.emit === "function") {
          process.emit("uncaughtException", error);
          return;
        }
        console.error(error);
      } catch (_a) {}
    }
    var Global = typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : typeof _globalThis !== "undefined" ? _globalThis : void 0;
    var currentWarnHandler;
    function setWarningHandler(value) {
      assertType(typeof value === "function" || value === void 0, "The warning handler must be a function or undefined, but got %o.", value);
      currentWarnHandler = value;
    }
    var Warning = /*#__PURE__*/function () {
      function Warning(code, message) {
        _classCallCheck(this, Warning);
        this.code = code;
        this.message = message;
      }
      return _createClass(Warning, [{
        key: "warn",
        value: function warn() {
          var _a;
          try {
            var _console, _context;
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            if (currentWarnHandler) {
              currentWarnHandler(_objectSpread(_objectSpread({}, this), {}, {
                args: args
              }));
              return;
            }
            var stack = ((_a = new Error().stack) !== null && _a !== void 0 ? _a : "").replace(/^(?:(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?\n){2}/g, "\n");
            (_console = console).warn.apply(_console, _concatInstanceProperty(_context = [this.message]).call(_context, args, [stack]));
          } catch (_b) {}
        }
      }]);
    }();
    var InitEventWasCalledWhileDispatching = new Warning("W01", "Unable to initialize event under dispatching.");
    var FalsyWasAssignedToCancelBubble = new Warning("W02", "Assigning any falsy value to 'cancelBubble' property has no effect.");
    var TruthyWasAssignedToReturnValue = new Warning("W03", "Assigning any truthy value to 'returnValue' property has no effect.");
    var NonCancelableEventWasCanceled = new Warning("W04", "Unable to preventDefault on non-cancelable events.");
    var CanceledInPassiveListener = new Warning("W05", "Unable to preventDefault inside passive event listener invocation.");
    var EventListenerWasDuplicated = new Warning("W06", "An event listener wasn't added because it has been added already: %o, %o");
    var OptionWasIgnored = new Warning("W07", "The %o option value was abandoned because the event listener wasn't added as duplicated.");
    var InvalidEventListener = new Warning("W08", "The 'callback' argument must be a function or an object that has 'handleEvent' method: %o");
    var InvalidAttributeHandler = new Warning("W09", "Event attribute handler must be a function: %o");
    var Event = /*#__PURE__*/function () {
      function Event(type, eventInitDict) {
        _classCallCheck(this, Event);
        _Object$defineProperty(this, "isTrusted", {
          value: false,
          enumerable: true
        });
        var opts = eventInitDict !== null && eventInitDict !== void 0 ? eventInitDict : {};
        internalDataMap.set(this, {
          type: String(type),
          bubbles: Boolean(opts.bubbles),
          cancelable: Boolean(opts.cancelable),
          composed: Boolean(opts.composed),
          target: null,
          currentTarget: null,
          stopPropagationFlag: false,
          stopImmediatePropagationFlag: false,
          canceledFlag: false,
          inPassiveListenerFlag: false,
          dispatchFlag: false,
          timeStamp: _Date$now()
        });
      }
      return _createClass(Event, [{
        key: "type",
        get: function get() {
          return $(this).type;
        }
      }, {
        key: "target",
        get: function get() {
          return $(this).target;
        }
      }, {
        key: "srcElement",
        get: function get() {
          return $(this).target;
        }
      }, {
        key: "currentTarget",
        get: function get() {
          return $(this).currentTarget;
        }
      }, {
        key: "composedPath",
        value: function composedPath() {
          var currentTarget = $(this).currentTarget;
          if (currentTarget) {
            return [currentTarget];
          }
          return [];
        }
      }, {
        key: "NONE",
        get: function get() {
          return NONE;
        }
      }, {
        key: "CAPTURING_PHASE",
        get: function get() {
          return CAPTURING_PHASE;
        }
      }, {
        key: "AT_TARGET",
        get: function get() {
          return AT_TARGET;
        }
      }, {
        key: "BUBBLING_PHASE",
        get: function get() {
          return BUBBLING_PHASE;
        }
      }, {
        key: "eventPhase",
        get: function get() {
          return $(this).dispatchFlag ? 2 : 0;
        }
      }, {
        key: "stopPropagation",
        value: function stopPropagation() {
          $(this).stopPropagationFlag = true;
        }
      }, {
        key: "cancelBubble",
        get: function get() {
          return $(this).stopPropagationFlag;
        },
        set: function set(value) {
          if (value) {
            $(this).stopPropagationFlag = true;
          } else {
            FalsyWasAssignedToCancelBubble.warn();
          }
        }
      }, {
        key: "stopImmediatePropagation",
        value: function stopImmediatePropagation() {
          var data = $(this);
          data.stopPropagationFlag = data.stopImmediatePropagationFlag = true;
        }
      }, {
        key: "bubbles",
        get: function get() {
          return $(this).bubbles;
        }
      }, {
        key: "cancelable",
        get: function get() {
          return $(this).cancelable;
        }
      }, {
        key: "returnValue",
        get: function get() {
          return !$(this).canceledFlag;
        },
        set: function set(value) {
          if (!value) {
            setCancelFlag($(this));
          } else {
            TruthyWasAssignedToReturnValue.warn();
          }
        }
      }, {
        key: "preventDefault",
        value: function preventDefault() {
          setCancelFlag($(this));
        }
      }, {
        key: "defaultPrevented",
        get: function get() {
          return $(this).canceledFlag;
        }
      }, {
        key: "composed",
        get: function get() {
          return $(this).composed;
        }
      }, {
        key: "isTrusted",
        get: function get() {
          return false;
        }
      }, {
        key: "timeStamp",
        get: function get() {
          return $(this).timeStamp;
        }
      }, {
        key: "initEvent",
        value: function initEvent(type) {
          var bubbles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var cancelable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          var data = $(this);
          if (data.dispatchFlag) {
            InitEventWasCalledWhileDispatching.warn();
            return;
          }
          internalDataMap.set(this, _objectSpread(_objectSpread({}, data), {}, {
            type: String(type),
            bubbles: Boolean(bubbles),
            cancelable: Boolean(cancelable),
            target: null,
            currentTarget: null,
            stopPropagationFlag: false,
            stopImmediatePropagationFlag: false,
            canceledFlag: false
          }));
        }
      }], [{
        key: "NONE",
        get: function get() {
          return NONE;
        }
      }, {
        key: "CAPTURING_PHASE",
        get: function get() {
          return CAPTURING_PHASE;
        }
      }, {
        key: "AT_TARGET",
        get: function get() {
          return AT_TARGET;
        }
      }, {
        key: "BUBBLING_PHASE",
        get: function get() {
          return BUBBLING_PHASE;
        }
      }]);
    }();
    var NONE = 0;
    var CAPTURING_PHASE = 1;
    var AT_TARGET = 2;
    var BUBBLING_PHASE = 3;
    var internalDataMap = /* @__PURE__ */new _WeakMap();
    function $(event) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "this";
      var retv = internalDataMap.get(event);
      assertType(retv != null, "'%s' must be an object that Event constructor created, but got another one: %o", name, event);
      return retv;
    }
    function setCancelFlag(data) {
      if (data.inPassiveListenerFlag) {
        CanceledInPassiveListener.warn();
        return;
      }
      if (!data.cancelable) {
        NonCancelableEventWasCanceled.warn();
        return;
      }
      data.canceledFlag = true;
    }
    _Object$defineProperty(Event, "NONE", {
      enumerable: true
    });
    _Object$defineProperty(Event, "CAPTURING_PHASE", {
      enumerable: true
    });
    _Object$defineProperty(Event, "AT_TARGET", {
      enumerable: true
    });
    _Object$defineProperty(Event, "BUBBLING_PHASE", {
      enumerable: true
    });
    var keys = _Object$getOwnPropertyNames(Event.prototype);
    for (var i = 0; i < keys.length; ++i) {
      if (keys[i] === "constructor") {
        continue;
      }
      _Object$defineProperty(Event.prototype, keys[i], {
        enumerable: true
      });
    }
    if (typeof Global !== "undefined" && typeof Global.Event !== "undefined") {
      _Object$setPrototypeOf(Event.prototype, Global.Event.prototype);
    }
    function createInvalidStateError(message) {
      if (Global.DOMException) {
        return new Global.DOMException(message, "InvalidStateError");
      }
      if (DOMException == null) {
        DOMException = /*#__PURE__*/function (_Error) {
          function DOMException2(msg) {
            var _this;
            _classCallCheck(this, DOMException2);
            _this = _callSuper(this, DOMException2, [msg]);
            if (Error.captureStackTrace) {
              Error.captureStackTrace(_this, DOMException2);
            }
            return _this;
          }
          _inherits(DOMException2, _Error);
          return _createClass(DOMException2, [{
            key: "code",
            get: function get() {
              return 11;
            }
          }, {
            key: "name",
            get: function get() {
              return "InvalidStateError";
            }
          }]);
        }(/*#__PURE__*/_wrapNativeSuper(Error));
        _Object$defineProperties(DOMException.prototype, {
          code: {
            enumerable: true
          },
          name: {
            enumerable: true
          }
        });
        defineErrorCodeProperties(DOMException);
        defineErrorCodeProperties(DOMException.prototype);
      }
      return new DOMException(message);
    }
    var DOMException;
    var ErrorCodeMap = {
      INDEX_SIZE_ERR: 1,
      DOMSTRING_SIZE_ERR: 2,
      HIERARCHY_REQUEST_ERR: 3,
      WRONG_DOCUMENT_ERR: 4,
      INVALID_CHARACTER_ERR: 5,
      NO_DATA_ALLOWED_ERR: 6,
      NO_MODIFICATION_ALLOWED_ERR: 7,
      NOT_FOUND_ERR: 8,
      NOT_SUPPORTED_ERR: 9,
      INUSE_ATTRIBUTE_ERR: 10,
      INVALID_STATE_ERR: 11,
      SYNTAX_ERR: 12,
      INVALID_MODIFICATION_ERR: 13,
      NAMESPACE_ERR: 14,
      INVALID_ACCESS_ERR: 15,
      VALIDATION_ERR: 16,
      TYPE_MISMATCH_ERR: 17,
      SECURITY_ERR: 18,
      NETWORK_ERR: 19,
      ABORT_ERR: 20,
      URL_MISMATCH_ERR: 21,
      QUOTA_EXCEEDED_ERR: 22,
      TIMEOUT_ERR: 23,
      INVALID_NODE_TYPE_ERR: 24,
      DATA_CLONE_ERR: 25
    };
    function defineErrorCodeProperties(obj) {
      var keys2 = _Object$keys(ErrorCodeMap);
      var _loop2 = function _loop2() {
        var key = keys2[_i];
        var value = ErrorCodeMap[key];
        _Object$defineProperty(obj, key, {
          get: function get() {
            return value;
          },
          configurable: true,
          enumerable: true
        });
      };
      for (var _i = 0; _i < keys2.length; ++_i) {
        _loop2();
      }
    }
    var EventWrapper = /*#__PURE__*/function (_Event) {
      function EventWrapper(event) {
        var _this2;
        _classCallCheck(this, EventWrapper);
        _this2 = _callSuper(this, EventWrapper, [event.type, {
          bubbles: event.bubbles,
          cancelable: event.cancelable,
          composed: event.composed
        }]);
        if (event.cancelBubble) {
          _superPropGet((_this2, EventWrapper), "stopPropagation", _this2, 3)([]);
        }
        if (event.defaultPrevented) {
          _superPropGet((_this2, EventWrapper), "preventDefault", _this2, 3)([]);
        }
        internalDataMap$1.set(_this2, {
          original: event
        });
        var keys2 = _Object$keys(event);
        for (var _i2 = 0; _i2 < keys2.length; ++_i2) {
          var key = keys2[_i2];
          if (!(key in _this2)) {
            _Object$defineProperty(_this2, key, defineRedirectDescriptor(event, key));
          }
        }
        return _this2;
      }
      _inherits(EventWrapper, _Event);
      return _createClass(EventWrapper, [{
        key: "stopPropagation",
        value: function stopPropagation() {
          _superPropGet(EventWrapper, "stopPropagation", this, 3)([]);
          var _$$ = $$1(this),
            original = _$$.original;
          if ("stopPropagation" in original) {
            original.stopPropagation();
          }
        }
      }, {
        key: "cancelBubble",
        get: function get() {
          return _superPropGet(EventWrapper, "cancelBubble", this, 1);
        },
        set: function set(value) {
          _superPropSet(EventWrapper, "cancelBubble", value, this, 1, 1);
          var _$$2 = $$1(this),
            original = _$$2.original;
          if ("cancelBubble" in original) {
            original.cancelBubble = value;
          }
        }
      }, {
        key: "stopImmediatePropagation",
        value: function stopImmediatePropagation() {
          _superPropGet(EventWrapper, "stopImmediatePropagation", this, 3)([]);
          var _$$3 = $$1(this),
            original = _$$3.original;
          if ("stopImmediatePropagation" in original) {
            original.stopImmediatePropagation();
          }
        }
      }, {
        key: "returnValue",
        get: function get() {
          return _superPropGet(EventWrapper, "returnValue", this, 1);
        },
        set: function set(value) {
          _superPropSet(EventWrapper, "returnValue", value, this, 1, 1);
          var _$$4 = $$1(this),
            original = _$$4.original;
          if ("returnValue" in original) {
            original.returnValue = value;
          }
        }
      }, {
        key: "preventDefault",
        value: function preventDefault() {
          _superPropGet(EventWrapper, "preventDefault", this, 3)([]);
          var _$$5 = $$1(this),
            original = _$$5.original;
          if ("preventDefault" in original) {
            original.preventDefault();
          }
        }
      }, {
        key: "timeStamp",
        get: function get() {
          var _$$6 = $$1(this),
            original = _$$6.original;
          if ("timeStamp" in original) {
            return original.timeStamp;
          }
          return _superPropGet(EventWrapper, "timeStamp", this, 1);
        }
      }], [{
        key: "wrap",
        value: function wrap(event) {
          return new (getWrapperClassOf(event))(event);
        }
      }]);
    }(Event);
    var internalDataMap$1 = /* @__PURE__ */new _WeakMap();
    function $$1(event) {
      var retv = internalDataMap$1.get(event);
      assertType(retv != null, "'this' is expected an Event object, but got", event);
      return retv;
    }
    var wrapperClassCache = /* @__PURE__ */new _WeakMap();
    wrapperClassCache.set(Object.prototype, EventWrapper);
    if (typeof Global !== "undefined" && typeof Global.Event !== "undefined") {
      wrapperClassCache.set(Global.Event.prototype, EventWrapper);
    }
    function getWrapperClassOf(originalEvent) {
      var prototype = _Object$getPrototypeOf(originalEvent);
      if (prototype == null) {
        return EventWrapper;
      }
      var wrapper = wrapperClassCache.get(prototype);
      if (wrapper == null) {
        wrapper = defineWrapper(getWrapperClassOf(prototype), prototype);
        wrapperClassCache.set(prototype, wrapper);
      }
      return wrapper;
    }
    function defineWrapper(BaseEventWrapper, originalPrototype) {
      var CustomEventWrapper = /*#__PURE__*/function (_BaseEventWrapper) {
        function CustomEventWrapper() {
          _classCallCheck(this, CustomEventWrapper);
          return _callSuper(this, CustomEventWrapper, arguments);
        }
        _inherits(CustomEventWrapper, _BaseEventWrapper);
        return _createClass(CustomEventWrapper);
      }(BaseEventWrapper);
      var keys2 = _Object$keys(originalPrototype);
      for (var _i3 = 0; _i3 < keys2.length; ++_i3) {
        _Object$defineProperty(CustomEventWrapper.prototype, keys2[_i3], defineRedirectDescriptor(originalPrototype, keys2[_i3]));
      }
      return CustomEventWrapper;
    }
    function defineRedirectDescriptor(obj, key) {
      var d = _Object$getOwnPropertyDescriptor(obj, key);
      return {
        get: function get() {
          var original = $$1(this).original;
          var value = original[key];
          if (typeof value === "function") {
            return _bindInstanceProperty(value).call(value, original);
          }
          return value;
        },
        set: function set(value) {
          var original = $$1(this).original;
          original[key] = value;
        },
        configurable: d.configurable,
        enumerable: d.enumerable
      };
    }
    function createListener(callback, capture, passive, once, signal, signalListener) {
      return {
        callback: callback,
        flags: (capture ? 1 : 0) | (passive ? 2 : 0) | (once ? 4 : 0),
        signal: signal,
        signalListener: signalListener
      };
    }
    function setRemoved(listener) {
      listener.flags |= 8;
    }
    function isCapture(listener) {
      return (_flagsInstanceProperty(listener) & 1) === 1;
    }
    function isPassive(listener) {
      return (_flagsInstanceProperty(listener) & 2) === 2;
    }
    function isOnce(listener) {
      return (_flagsInstanceProperty(listener) & 4) === 4;
    }
    function isRemoved(listener) {
      return (_flagsInstanceProperty(listener) & 8) === 8;
    }
    function invokeCallback(_ref, target, event) {
      var callback = _ref.callback;
      try {
        if (typeof callback === "function") {
          callback.call(target, event);
        } else if (typeof callback.handleEvent === "function") {
          callback.handleEvent(event);
        }
      } catch (thrownError) {
        reportError(thrownError);
      }
    }
    function findIndexOfListener(_ref2, callback, capture) {
      var listeners = _ref2.listeners;
      for (var _i4 = 0; _i4 < listeners.length; ++_i4) {
        if (listeners[_i4].callback === callback && isCapture(listeners[_i4]) === capture) {
          return _i4;
        }
      }
      return -1;
    }
    function addListener(list, callback, capture, passive, once, signal) {
      var signalListener;
      if (signal) {
        signalListener = _bindInstanceProperty(removeListener).call(removeListener, null, list, callback, capture);
        signal.addEventListener("abort", signalListener);
      }
      var listener = createListener(callback, capture, passive, once, signal, signalListener);
      if (list.cow) {
        var _context2;
        list.cow = false;
        list.listeners = _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(list.listeners), [listener]);
      } else {
        list.listeners.push(listener);
      }
      return listener;
    }
    function removeListener(list, callback, capture) {
      var index = findIndexOfListener(list, callback, capture);
      if (index !== -1) {
        return removeListenerAt(list, index);
      }
      return false;
    }
    function removeListenerAt(list, index) {
      var _context4;
      var disableCow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var listener = list.listeners[index];
      setRemoved(listener);
      if (listener.signal) {
        listener.signal.removeEventListener("abort", listener.signalListener);
      }
      if (list.cow && !disableCow) {
        var _context3;
        list.cow = false;
        list.listeners = _filterInstanceProperty(_context3 = list.listeners).call(_context3, function (_, i) {
          return i !== index;
        });
        return false;
      }
      _spliceInstanceProperty(_context4 = list.listeners).call(_context4, index, 1);
      return true;
    }
    function createListenerListMap() {
      return /* @__PURE__ */_Object$create(null);
    }
    function ensureListenerList(listenerMap, type) {
      var _a;
      return (_a = listenerMap[type]) !== null && _a !== void 0 ? _a : listenerMap[type] = {
        attrCallback: void 0,
        attrListener: void 0,
        cow: false,
        listeners: []
      };
    }
    var EventTarget2 = /*#__PURE__*/function () {
      function EventTarget2() {
        _classCallCheck(this, EventTarget2);
        internalDataMap$2.set(this, createListenerListMap());
      }
      return _createClass(EventTarget2, [{
        key: "addEventListener",
        value: function addEventListener(type0, callback0, options0) {
          var listenerMap = $$2(this);
          var _normalizeAddOptions = normalizeAddOptions(type0, callback0, options0),
            callback = _normalizeAddOptions.callback,
            capture = _normalizeAddOptions.capture,
            once = _normalizeAddOptions.once,
            passive = _normalizeAddOptions.passive,
            signal = _normalizeAddOptions.signal,
            type = _normalizeAddOptions.type;
          if (callback == null || (signal === null || signal === void 0 ? void 0 : signal.aborted)) {
            return;
          }
          var list = ensureListenerList(listenerMap, type);
          var i = findIndexOfListener(list, callback, capture);
          if (i !== -1) {
            warnDuplicate(list.listeners[i], passive, once, signal);
            return;
          }
          addListener(list, callback, capture, passive, once, signal);
        }
      }, {
        key: "removeEventListener",
        value: function removeEventListener(type0, callback0, options0) {
          var listenerMap = $$2(this);
          var _normalizeOptions = normalizeOptions(type0, callback0, options0),
            callback = _normalizeOptions.callback,
            capture = _normalizeOptions.capture,
            type = _normalizeOptions.type;
          var list = listenerMap[type];
          if (callback != null && list) {
            removeListener(list, callback, capture);
          }
        }
      }, {
        key: "dispatchEvent",
        value: function dispatchEvent(e) {
          var list = $$2(this)[String(e.type)];
          if (list == null) {
            return true;
          }
          var event = e instanceof Event ? e : EventWrapper.wrap(e);
          var eventData = $(event, "event");
          if (eventData.dispatchFlag) {
            throw createInvalidStateError("This event has been in dispatching.");
          }
          eventData.dispatchFlag = true;
          eventData.target = eventData.currentTarget = this;
          if (!eventData.stopPropagationFlag) {
            var cow = list.cow,
              listeners = list.listeners;
            list.cow = true;
            for (var _i5 = 0; _i5 < listeners.length; ++_i5) {
              var listener = listeners[_i5];
              if (isRemoved(listener)) {
                continue;
              }
              if (isOnce(listener) && removeListenerAt(list, _i5, !cow)) {
                _i5 -= 1;
              }
              eventData.inPassiveListenerFlag = isPassive(listener);
              invokeCallback(listener, this, event);
              eventData.inPassiveListenerFlag = false;
              if (eventData.stopImmediatePropagationFlag) {
                break;
              }
            }
            if (!cow) {
              list.cow = false;
            }
          }
          eventData.target = null;
          eventData.currentTarget = null;
          eventData.stopImmediatePropagationFlag = false;
          eventData.stopPropagationFlag = false;
          eventData.dispatchFlag = false;
          return !eventData.canceledFlag;
        }
      }]);
    }();
    var internalDataMap$2 = /* @__PURE__ */new _WeakMap();
    function $$2(target) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "this";
      var retv = internalDataMap$2.get(target);
      assertType(retv != null, "'%s' must be an object that EventTarget constructor created, but got another one: %o", name, target);
      return retv;
    }
    function normalizeAddOptions(type, callback, options) {
      var _a;
      assertCallback(callback);
      if (_typeof(options) === "object" && options !== null) {
        return {
          type: String(type),
          callback: callback !== null && callback !== void 0 ? callback : void 0,
          capture: Boolean(options.capture),
          passive: Boolean(options.passive),
          once: Boolean(options.once),
          signal: (_a = options.signal) !== null && _a !== void 0 ? _a : void 0
        };
      }
      return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : void 0,
        capture: Boolean(options),
        passive: false,
        once: false,
        signal: void 0
      };
    }
    function normalizeOptions(type, callback, options) {
      assertCallback(callback);
      if (_typeof(options) === "object" && options !== null) {
        return {
          type: String(type),
          callback: callback !== null && callback !== void 0 ? callback : void 0,
          capture: Boolean(options.capture)
        };
      }
      return {
        type: String(type),
        callback: callback !== null && callback !== void 0 ? callback : void 0,
        capture: Boolean(options)
      };
    }
    function assertCallback(callback) {
      if (typeof callback === "function" || _typeof(callback) === "object" && callback !== null && typeof callback.handleEvent === "function") {
        return;
      }
      if (callback == null || _typeof(callback) === "object") {
        InvalidEventListener.warn(callback);
        return;
      }
      throw new TypeError(format(InvalidEventListener.message, [callback]));
    }
    function warnDuplicate(listener, passive, once, signal) {
      EventListenerWasDuplicated.warn(isCapture(listener) ? "capture" : "bubble", listener.callback);
      if (isPassive(listener) !== passive) {
        OptionWasIgnored.warn("passive");
      }
      if (isOnce(listener) !== once) {
        OptionWasIgnored.warn("once");
      }
      if (listener.signal !== signal) {
        OptionWasIgnored.warn("signal");
      }
    }
    var keys$1 = _Object$getOwnPropertyNames(EventTarget2.prototype);
    for (var _i6 = 0; _i6 < keys$1.length; ++_i6) {
      if (keys$1[_i6] === "constructor") {
        continue;
      }
      _Object$defineProperty(EventTarget2.prototype, keys$1[_i6], {
        enumerable: true
      });
    }
    if (typeof Global !== "undefined" && typeof Global.EventTarget !== "undefined") {
      _Object$setPrototypeOf(EventTarget2.prototype, Global.EventTarget.prototype);
    }
    function getEventAttributeValue(target, type) {
      var _a, _b;
      var listMap = $$2(target, "target");
      return (_b = (_a = listMap[type]) === null || _a === void 0 ? void 0 : _a.attrCallback) !== null && _b !== void 0 ? _b : null;
    }
    function setEventAttributeValue(target, type, callback) {
      if (callback != null && typeof callback !== "function") {
        InvalidAttributeHandler.warn(callback);
      }
      if (typeof callback === "function" || _typeof(callback) === "object" && callback !== null) {
        upsertEventAttributeListener(target, type, callback);
      } else {
        removeEventAttributeListener(target, type);
      }
    }
    function upsertEventAttributeListener(target, type, callback) {
      var list = ensureListenerList($$2(target, "target"), String(type));
      list.attrCallback = callback;
      if (list.attrListener == null) {
        list.attrListener = addListener(list, defineEventAttributeCallback(list), false, false, false, void 0);
      }
    }
    function removeEventAttributeListener(target, type) {
      var listMap = $$2(target, "target");
      var list = listMap[String(type)];
      if (list && list.attrListener) {
        removeListener(list, list.attrListener.callback, false);
        list.attrCallback = list.attrListener = void 0;
      }
    }
    function defineEventAttributeCallback(list) {
      return function (event) {
        var callback = list.attrCallback;
        if (typeof callback === "function") {
          callback.call(this, event);
        }
      };
    }
    function defineCustomEventTarget() {
      var CustomEventTarget = /*#__PURE__*/function (_EventTarget) {
        function CustomEventTarget() {
          _classCallCheck(this, CustomEventTarget);
          return _callSuper(this, CustomEventTarget, arguments);
        }
        _inherits(CustomEventTarget, _EventTarget);
        return _createClass(CustomEventTarget);
      }(EventTarget2);
      for (var _i7 = 0; _i7 < arguments.length; ++_i7) {
        defineEventAttribute2(CustomEventTarget.prototype, _i7 < 0 || arguments.length <= _i7 ? undefined : arguments[_i7]);
      }
      return CustomEventTarget;
    }
    function defineEventAttribute2(target, type, _eventClass) {
      _Object$defineProperty(target, "on".concat(type), {
        get: function get() {
          return getEventAttributeValue(this, type);
        },
        set: function set(value) {
          setEventAttributeValue(this, type, value);
        },
        configurable: true,
        enumerable: true
      });
    }
    exports.Event = Event;
    exports.EventTarget = EventTarget2;
    exports["default"] = EventTarget2;
    exports.defineCustomEventTarget = defineCustomEventTarget;
    exports.defineEventAttribute = defineEventAttribute2;
    exports.getEventAttributeValue = getEventAttributeValue;
    exports.setErrorHandler = setErrorHandler;
    exports.setEventAttributeValue = setEventAttributeValue;
    exports.setWarningHandler = setWarningHandler;
  }
});

// ../abort-controller/dist/abort-controller.mjs
var import_event_target_shim = __toESM(require_event_target_shim(), 1);
var AbortSignal = /*#__PURE__*/function (_import_event_target_) {
  function AbortSignal() {
    var _this3;
    _classCallCheck(this, AbortSignal);
    _this3 = _callSuper(this, AbortSignal);
    throw new TypeError("AbortSignal cannot be constructed directly");
    return _this3;
  }
  _inherits(AbortSignal, _import_event_target_);
  return _createClass(AbortSignal, [{
    key: "aborted",
    get: function get() {
      var aborted = abortedFlags.get(this);
      if (typeof aborted !== "boolean") {
        throw new TypeError("Expected 'this' to be an 'AbortSignal' object, but got ".concat(this === null ? "null" : _typeof(this)));
      }
      return aborted;
    }
  }]);
}(import_event_target_shim.EventTarget);
(0, import_event_target_shim.defineEventAttribute)(AbortSignal.prototype, "abort");
function createAbortSignal() {
  var signal = _Object$create(AbortSignal.prototype);
  import_event_target_shim.EventTarget.call(signal);
  abortedFlags.set(signal, false);
  return signal;
}
function abortSignal(signal) {
  if (abortedFlags.get(signal) !== false) {
    return;
  }
  abortedFlags.set(signal, true);
  signal.dispatchEvent({
    type: "abort"
  });
}
var abortedFlags = /* @__PURE__ */new _WeakMap();
_Object$defineProperties(AbortSignal.prototype, {
  aborted: {
    enumerable: true
  }
});
if (typeof _Symbol === "function" && _typeof(_Symbol$toStringTag) === "symbol") {
  _Object$defineProperty(AbortSignal.prototype, _Symbol$toStringTag, {
    configurable: true,
    value: "AbortSignal"
  });
}
var AbortController = /*#__PURE__*/function () {
  function AbortController() {
    _classCallCheck(this, AbortController);
    signals.set(this, createAbortSignal());
  }
  return _createClass(AbortController, [{
    key: "signal",
    get: function get() {
      return getSignal(this);
    }
  }, {
    key: "abort",
    value: function abort() {
      abortSignal(getSignal(this));
    }
  }]);
}();
var signals = /* @__PURE__ */new _WeakMap();
function getSignal(controller) {
  var signal = signals.get(controller);
  if (signal == null) {
    throw new TypeError("Expected 'this' to be an 'AbortController' object, but got ".concat(controller === null ? "null" : _typeof(controller)));
  }
  return signal;
}
_Object$defineProperties(AbortController.prototype, {
  signal: {
    enumerable: true
  },
  abort: {
    enumerable: true
  }
});
if (typeof _Symbol === "function" && _typeof(_Symbol$toStringTag) === "symbol") {
  _Object$defineProperty(AbortController.prototype, _Symbol$toStringTag, {
    configurable: true,
    value: "AbortController"
  });
}
var abort_controller_default = AbortController;

// src/index.mjs
var NativeAbortController = (typeof window === "undefined" ? {} : window).AbortController;
var AbortController2 = NativeAbortController || abort_controller_default;
var NativeAbortSignal = (typeof window === "undefined" ? {} : window).AbortSignal;
var AbortSignal2 = NativeAbortSignal || AbortSignal;
var src_default = AbortController2;
export { AbortController2 as AbortController, AbortSignal2 as AbortSignal, src_default as default };
